module.exports = __webpack_public_path__ + "media/images/components/c03-welcome-helpline/image-1cb777dd308ac2d8396c40681e64fb74.svg";